
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-events/sample-menus",
      function () {
        return require("private-next-pages/private-events/sample-menus.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-events/sample-menus"])
      });
    }
  